import { PropsWithChildren } from "react";

import { ImageBackground } from "expo-image";
import { useTailwind } from "tailwind-rn";

export default function Background({ children }: PropsWithChildren) {
  const tailwind = useTailwind();

  return (
    <ImageBackground
      source={require("../assets/bg-success-blur.png")}
      style={tailwind("flex-1")}
    >
      {children}
    </ImageBackground>
  );
}
